<template>
    <div>
        <v-layout row wrap justify-center>
              <v-flex xs12 sm7 md7 >
                  <dialogos-app :dialogos="dialogosRegion" tucan="0"></dialogos-app>
              </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center mt-4>
            <v-flex xs12 sm7 md7 class="cont-img">
                <video :src="url" buffered controls 
                       :width="widthVideo" 
                       controlslist="nodownload"
                       @ended="$store.commit('nextShow',true)" 
                ></video>
            </v-flex>
        </v-layout>        
    </div>
</template>

<script>
export default {
    data(){
        return {
            dialogosRegion:[
                'Espírito Santo, Minas Gerais, Rio de Janeiro e São Paulo são os estados que fazem parte da Região Sudeste.',
                'São Paulo é a “cidade que nunca dorme”. Clique no vídeo e conheça melhor essa cidade.'
            ],
            widthVideo:'100%',
            url: 'videos/ibraco-presentacion-3.mp4',
        }
    }
}
</script>